import { render, staticRenderFns } from "./DataServices.vue?vue&type=template&id=7b5faa40&scoped=true"
import script from "./DataServices.vue?vue&type=script&lang=js"
export * from "./DataServices.vue?vue&type=script&lang=js"
import style0 from "./DataServices.vue?vue&type=style&index=0&id=7b5faa40&prod&lang=scss&scoped=true"
import style1 from "./DataServices.vue?vue&type=style&index=1&id=7b5faa40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5faa40",
  null
  
)

export default component.exports